import React from 'react';
import { block } from 'bem-cn';

import Typography from '../Typography';

import SuggestedActionPlate, {
  SuggestedActionPlateType,
} from '../SuggestedActionPlate';

import './suggested-actions-block.scss';

const b = block('suggested-actions-block');

export declare type SuggestedActionsBlockPropsType = {
  title: string;
  suggestedActions: SuggestedActionPlateType[];
  onSuggestedActionClick: (suggestedAction: any) => void;
};

const SuggestedActionsBlock = ({
  title,
  suggestedActions = [],
  onSuggestedActionClick,
}: SuggestedActionsBlockPropsType) => {
  const onSuggestedActionClickHandler = (suggestedAction: any) => {
    onSuggestedActionClick(suggestedAction);
  };

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('icon')} />
        <div className={b('title')}>
          <Typography
            component='div'
            variant={Typography.THEME.VARIANTS.TITLE_NORMAL}
          >
            {title}
          </Typography>
        </div>
      </div>
      <div className={b('suggested-actions')}>
        {suggestedActions.map((action) => (
          <SuggestedActionPlate
            key={action.id}
            suggestedAction={action}
            onClick={() => onSuggestedActionClickHandler(action)}
          />
        ))}
      </div>
    </div>
  );
};

export default SuggestedActionsBlock;
